/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router';
//metrics
import AverageInView from 'pages/dashboard/analytics/detail/metrics/averageinview/averageinview_container';
import CPM from 'pages/dashboard/analytics/detail/metrics/cpm/cpm_container';
import Revenue from 'pages/dashboard/analytics/detail/metrics/revenue/revenue_container';
import Impressions from 'pages/dashboard/analytics/detail/metrics/impressions/impressions_container';
import QuestionsAnswered from 'pages/dashboard/analytics/detail/metrics/questionsanswered/questionsanswered_container';
import UniqueEngagedUsers from 'pages/dashboard/analytics/detail/metrics/uniqueengagedusers/uniqueengagedusers_container';
import TopStoryClicks from 'pages/dashboard/analytics/detail/metrics/topstoryclicks/topstoryclicks_container';
import StoryClicks from 'pages/dashboard/analytics/detail/metrics/storyclicks/storyclicks_container';
import TopQuestionsAnswered from 'pages/dashboard/analytics/detail/metrics/topquestionsanswered/topquestionsanswered_container';
import PervasiveMessage from 'material/message/pervasivemessage/pervasivemessage_container';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/analytics/detail/detail_styles';




/* ========== ~~~~~~~~~~ PAGE : ANALYTICS : DETAIL : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const DataDetailPage = props => {

    return (
        <div className={`detail ${props.classes.detail}`}>
            <PervasiveMessage padding={26}/>
            <Switch>
                <Route path={`/dashboard/analytics/detail/cpm`} component={CPM} />
                <Route path={`/dashboard/analytics/detail/impression`} component={Impressions} />
                <Route path={`/dashboard/analytics/detail/revenue`} component={Revenue} />
                <Route path={`/dashboard/analytics/detail/averageinview`} component={AverageInView} />
                <Route path={`/dashboard/analytics/detail/questionsanswered`} component={QuestionsAnswered} />
                <Route path={`/dashboard/analytics/detail/uniqueengagedusers`} component={UniqueEngagedUsers} />
                <Route path={`/dashboard/analytics/detail/topquestionsanswered`} component={TopQuestionsAnswered} />
                <Route path={`/dashboard/analytics/detail/topstoryclicks`} component={TopStoryClicks} />
                <Route path={`/dashboard/analytics/detail/storyclicks`} component={StoryClicks} />
                <Redirect to={'/error/404'}/>
            </Switch>
        </div>
    );

}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(DataDetailPage);
